import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login/Login';
import VerifyCCAuthForm from '@/components/Login/VerifyCCAuthForm';
import Order from '@/components/Order/Order';
import CustomerCardDetail from '@/components/Order/CustomerCardDetail';
import CustomerCardDetailInternal from '@/components/Order/CustomerCardDetailInternal';
import NoAccessPermission from '@/components/AccessDenied/NoAccessPermission';




// import ListResource from '@/components/ResourceMaster/ListResource';
// import AddUpdateResource from '@/components/ResourceMaster/AddUpdateResource';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
          path: '/order',
          name: 'Order',
          component: Order
        },
        {
          path: '/form/detail',
          name: 'CustomerCardDetail',
          component: CustomerCardDetail
        },
        {
          path: '/form/detail/internal',
          name: 'CustomerCardDetailInternal',
          component: CustomerCardDetailInternal
        },
        {
          path: '/form',
          name: 'VerifyCCAuthForm',
          component: VerifyCCAuthForm
        },
        {
          path: '/acc',
          name: 'NoAccessPermission',
          component: NoAccessPermission
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js